import type { SelectChangeEvent } from "@mui/material";
import { Container, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import NoAccessIcon from "@entrilia/shared/icons/NoAccessIcon";
import { useImportCsvDataContext } from "../ImportCsvDataContext";
import {
  changeObjectTypeSelectionAction,
  changeTargetOptionSelectionAction,
  getObjectTypeOptions,
} from "../importCsvDataPageState";
import ImportCsvTargetCard from "./ImportCsvTargetCard";

const ImportCsvDataTargetSelectionStep = () => {
  const { pageState, setPageState } = useImportCsvDataContext();

  const handleChangeObjectType = (e: SelectChangeEvent) => {
    const selectedObjectType = e.target.value;
    setPageState(changeObjectTypeSelectionAction(selectedObjectType));
  };

  const handleToggleDataTypeTarget = (key: string) => (newSelected: boolean) => {
    setPageState(changeTargetOptionSelectionAction(key, newSelected));
  };

  if (pageState.targetOptions.length === 0) {
    return (
      <Container sx={{ height: "100%" }}>
        <Stack spacing={3} sx={{ py: 2.5, mx: "auto", width: "24rem" }}>
          <NoAccessIcon />
          <Typography variant="subtitle2">
            You do not have enough permissions to any available CSV data import target.
          </Typography>
        </Stack>
      </Container>
    );
  }

  return (
    <Container sx={{ height: "100%" }}>
      <Stack spacing={3} sx={{ py: 2.5, mx: "auto", height: "100%", width: "25rem" }}>
        <Typography color="textSecondary">Select the object type and data you wish to import.</Typography>
        <FormControl>
          <InputLabel id="object-type-select-label">Object Type</InputLabel>
          <Select
            fullWidth
            labelId="object-type-select-label"
            label="Object Type"
            value={pageState.selectedObjectType || ""}
            onChange={handleChangeObjectType}
          >
            {getObjectTypeOptions(pageState).map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <ScrollableFlexContainer>
          {pageState.selectedObjectType && (
            <Stack spacing={1} sx={{ flex: 1 }}>
              <Typography variant="subtitle2">Data</Typography>
              {pageState.targetOptions
                .filter(({ objectType }) => objectType === pageState.selectedObjectType)
                .map((target) => (
                  <ImportCsvTargetCard
                    key={target.key}
                    targetOption={target}
                    onToggleSelected={handleToggleDataTypeTarget(target.key)}
                  />
                ))}
            </Stack>
          )}
        </ScrollableFlexContainer>
      </Stack>
    </Container>
  );
};

export default ImportCsvDataTargetSelectionStep;
